import {prop} from "ramda";
import {Articles} from "../articles/entities";
import {saveSlugsFromRels} from "../../features/stories/interceptors";
import API from "..";

const searchStories = ({
  term,
  author,
  category,
  page,
  pageSize,
  orderBy,
  startDate,
  endDate,
  tag,
}) =>
  API.News.searchStories({
    term,
    author,
    category,
    page_size: pageSize,
    page,
    order_by: orderBy,
    start_date: startDate,
    end_date: endDate,
    tag,
  })
    .then(prop("data"))
    .then(saveSlugsFromRels)
    .then(Articles);

export default searchStories;
